<div class="custom-select-wrapper" [style.minWidth]="minWidth">
	<div
		#selectTrigger
		class="filter-select custom-select-trigger"
		[class.disabled]="disabled"
		tabindex="0"
		(click)="toggleDropdown()"
		(keydown.enter)="toggleDropdown()"
		(keydown.space)="toggleDropdown()">
		<span>{{ getSelectionLabel() }}</span>
		<span class="dropdown-arrow"><fa-icon [icon]="icon.faAngleDown"></fa-icon></span>
	</div>

	<div
		#dropdownPanel
		class="custom-dropdown"
		[style.maxHeight]="maxDropdownHeight"
		[mspDropdownBehaviour]="isDropdownOpen"
		[mspDropdownBehaviourTrigger]="selectTrigger"
		(mspDropdownBehaviourCollapsed)="isDropdownOpen = false">
		<div class="dropdown-option" (click)="clearSelection($event)">
			<input type="checkbox" class="checkbox-color" [checked]="selectedValues.length === 0" />
			<span>{{ allLabel }}</span>
		</div>

		@for (option of options; let index = $index; track index) {
			<div class="dropdown-option" (click)="toggleSelection(option, $event)">
				<input type="checkbox" class="checkbox-color" [checked]="option.selected" />
				<span [class.group-header-text]="option.emphasized">{{ option.label }}</span>
			</div>

			@for (childrenOption of option.children; let childIndex = $index; track childIndex) {
				<div class="dropdown-option children" (click)="toggleSelection(childrenOption, $event)">
					<input type="checkbox" class="checkbox-color" [checked]="childrenOption.selected" />
					<span [class.group-header-text]="childrenOption.emphasized">{{ childrenOption.label }}</span>
				</div>
			}
		}
	</div>
</div>
